import { useDateStore } from '@/components/DateInput'
import { createInstance } from '@/helpers/api/base'
import { IRtnTripAsNumber } from '@/types/logs'
import { format } from 'date-fns'
import { useAppQuery } from '@/helpers/api/query'
import { useCombinedLogsTableFormStateStore } from '../store'
import { useOffline } from '@/components/Header/hooks/useOffline'
import { useGetRoutesForRole } from '@/pages/ControlSheet/hooks/useGetRoutesForRole'

interface ITripsResponse {
    inbound: IRtnTripAsNumber[]
    outbound: IRtnTripAsNumber[]
}

export const useGetTrips = (trip?: string) => {
    const { date } = useDateStore()
    const formattedDate = format(date, 'yyyy/MM/dd')
    const { route } = useCombinedLogsTableFormStateStore()
    const { allRoutes: routes } = useGetRoutesForRole()
    const sortedRoutes = [...routes].sort()
    const concatRoutes = sortedRoutes.join(',')
    const isOffline = useOffline()
    const keyRoot = ['controllerLogsExtraInfo', formattedDate]
    const queryKey = isOffline || !route ? [...keyRoot, concatRoutes] : [...keyRoot, route]

    return useAppQuery<ITripsResponse>({
        queryKey,
        queryFn: ({ queryKey }) =>
            createInstance({
                url: '/controller-logs/extra-info',
                method: 'GET',
                params: {
                    Date: queryKey[1],
                    ...(isOffline || !route ? { Routes: routes } : { Routes: queryKey[2] }),
                },
                paramsSerializer: {
                    indexes: null,
                },
            }),
        select: (data) => {
            const filterByRoute = (items: IRtnTripAsNumber[]) =>
                isOffline && route ? items.filter((item) => item.route === route) : items

            const inbound = filterByRoute(data.inbound)
            const outbound = filterByRoute(data.outbound)

            const tripNum = trip ? parseInt(trip, 10) : null

            if (!trip && !tripNum) {
                return { inbound, outbound }
            }

            const tripToFilter = [...inbound, ...outbound].find((item) => item.trip === tripNum)

            const filterTrips = (items: IRtnTripAsNumber[]): IRtnTripAsNumber[] => {
                return items.filter((item) => item.run === tripToFilter?.run && tripNum && item.trip > tripNum)
            }

            return {
                inbound: filterTrips(inbound),
                outbound: filterTrips(outbound),
            }
        },
        enabled: routes.length > 0 && !!formattedDate,
        retry: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retryOnMount: false,
    })
}
